import qs from 'qs';

import { client } from '../client';
import { IListUsers, IListUsersParams } from './listAllUsers';

export const listCareAdvisorUsers = async (params?: IListUsersParams): Promise<IListUsers> => {
  const { data } = await client.get<IListUsers>(
    `/care_advisor/users?${qs.stringify(params, { skipNulls: true, arrayFormat: 'repeat' })}`,
  );

  return data;
};
